// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__luh6n","item":"styles_item__2fskf","img":"styles_img__1RZ9i","content":"styles_content__1n4aY","text":"styles_text__i8ZC-"};